import { Container } from '@material-ui/core';
import memorialProjectImage from '@static/memorial-project.png';
import useLanguageStore from '@stores/languageStore';
import { useTranslation } from 'react-i18next';
import ProjectCard from '../../components/cards/ProjectCard';
import SectionHeader from '../../components/SectionHeader';
import SEOHead from '../../components/SEOHead';

const ProjectsPage = () => {
  const { t } = useTranslation();
  const { language } = useLanguageStore();
  const isRtl = language === 'he';

  return (
    <div
      className={`h-[calc(100vh-64px)] py-20 sm:py-32 overflow-y-auto sm:overflow-y-hidden max-w-[100vw] overflow-x-hidden ${
        isRtl ? 'rtl' : 'ltr'
      }`}
    >
      <Container maxWidth="lg" className="px-4 sm:px-8">
        <SEOHead
          title={t('projects.title')}
          description={t('projects.subtitle')}
        />
        <SectionHeader
          title={t('projects.title')}
          subtitle={t('projects.subtitle')}
          className="mb-8"
          component="h1"
        />

        <ProjectCard
          title={t('projects.memorial.title')}
          description={t('projects.memorial.description')}
          imageSrc={memorialProjectImage}
          imageAlt={t('projects.memorial.title')}
          isRtl={isRtl}
          imageOnLeft={false}
        />
      </Container>
    </div>
  );
};

export default ProjectsPage;
